import { Tag, _Object } from '@aws-sdk/client-s3';

/**
 * Used to transfer tagged S3 Objects to the client
 */
export type TaggedObject = _Object & { Tagging: Tag[] | undefined };
